<template>
  <div class="popup-main">
    <el-dialog title="提示" width="500px" :visible.sync="selfShow" :close-on-click-modal="false">
      <div class="flex">
        <span class="el-icon-success f-s-24 c-green"></span>
        <div class="m-l-5 m-t-2">
          <span class="f-s-16 f-bold">操作成功</span>
          <div class="m-t-10">
            销售订单「<span class="c-red">{{ code }}</span
            >」新增并引用成功，请前往核算单列表继续操作。
          </div>
        </div>
      </div>
      <div slot="footer">
        <el-button size="mini" type="primary" @click="popupConfirm">核算单列表</el-button>
        <el-button size="mini" @click="popupCancel">我知道了</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      required: true
    },
    code: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      selfShow: false
    }
  },
  mounted() {
    this.selfShow = this.show
  },
  methods: {
    // 弹窗取消
    popupCancel() {
      this.selfShow = false
      this.$emit('update:show', false)
    },
    // 弹窗确认
    popupConfirm() {
      this.popupCancel()
      window.open('/new/verify/list', '_blank')
    }
  }
}
</script>

<style lang="less" scoped>
.popup-main {
}
</style>
